var React = require('react');

function ButtonArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5 1a1 1 0 0 1 1.414 0l7 7-7 7A1 1 0 1 1 5 13.586L10.586 8 5 2.414A1 1 0 0 1 5 1z","fill":"#000"}));
}

ButtonArrow.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ButtonArrow;

ButtonArrow.default = ButtonArrow;
